
import { Container, CardDeck, Row, Col, Image } from 'react-bootstrap';
//import 'holderjs';
import React from 'react';
import '../css/Home.css';
import GameCard from '../components/GameCard';
import sodiumTube from '../img/jams/AnyoneForSodiumTube.png';
import galaxyDefenders from '../img/jams/GalaxyDefenders.png';
import PrairieDogSim from '../img/jams/PrairieDogSim.gif';
import STARSSpaceTime from '../img/jams/STARSSpaceTime.gif';
import monsterHouse from '../img/jams/MonsterHouse.png';
import lessHealthMoreKill from '../img/jams/lessHealthMoreKill.gif';
import schoolOfFish from '../img/jams/SchoolOfFish.gif';

import itchIO from '../img/availableOnItchIO.svg'



function Jams() {
    return <Container className="page-container px-0">
        <Container className="p-3"><Row><Col>Game jams are competitions where contestants are challenged to complete development of a game within a certain timeframe. Most game jams also include a theme that the developer should try to implement within the game.</Col></Row></Container>
        <Container className="p-3">
            <Row className="justify-content-center home-game-card-row">
                <GameCard colsize="col-2" title="Anyone For A Sodium Tube?" description="Created for #LOWREZJAM 2016" imgPath={sodiumTube} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/anyone-for-a-sodium-tube" />
                <GameCard colsize="col-2" title="Galaxy Defenders" description="Built for Stop Motion Game Jam 2018" imgPath={galaxyDefenders} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/galaxy-defenders" />
                <GameCard colsize="col-2" title="Prairie Dog Simulator" description="This was completed within a week for Brackeys Game Jam 2020.1" imgPath={PrairieDogSim} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/prairie-dog-simulator" />
                <GameCard colsize="col-2" title="S.T.A.R.S: Space Time Anomaly Research" description="Submission for: Brackeys Game Jam 2020.2" imgPath={STARSSpaceTime} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/space-time-anomaly-research" />
                <GameCard colsize="col-2" title="Monster House" description="Created with my kids. Made for our personal jam." imgPath={monsterHouse} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/monster-house" />
                <GameCard colsize="col-2" title="LESS HEALTH MORE KILL" description="My submission for Blackthornprod GAME JAM #3" imgPath={lessHealthMoreKill} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/less-health-more-kill" />
                <GameCard colsize="col-2" title="School of FISH" description="Created for Brackeys Game Jam 2021.1" imgPath={schoolOfFish} playImage={itchIO} gameURL="#" playURL="https://spacecastle.itch.io/school-of-fish" />
            </Row>
        </Container>
    </Container >
}

export default Jams;
